import type { RxJsonSchema } from 'rxdb';
import type { TaskList } from './taskList.types';

export const taskListSchema: RxJsonSchema<TaskList> = {
  type: 'object',
  version: 3,
  description: 'describes deficiency lists',
  primaryKey: 'pkUuId',
  properties: {
    pkAssetInspectionTask: { type: 'number' },
    fkSchedule: { type: ['number', 'null'] },
    fkAssetInspection: { type: ['number', 'null'] },
    pkUuId: { type: 'string', maxLength: 36 },
    isActive: { type: ['boolean', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    fkInspectorLead: { type: ['number', 'null'] },
    fkInspectorField: { type: ['number', 'null'] },
    name: { type: ['string', 'null'] },
    taskDescription: { type: ['string', 'null'] },
    isReviewedByLI: { type: ['boolean', 'null'] },
    isReviewedByFI: { type: ['boolean', 'null'] },
    commentInspectorLead: { type: ['string', 'null'] },
    commentInspectorField: { type: ['string', 'null'] },
    commentSiteCoordinator: { type: ['string', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    modifiedBy: { type: ['string', 'null'] },
    createdBy: { type: ['string', 'null'] },
    fkInspectionTaskStatusCategory: { type: ['number', 'null'] },
    attentionFlag: { type: ['boolean', 'null'] },
    isAssignedBack: { type: ['boolean', 'null'] },
    fieldInspectorUserId: { type: ['number', 'null'] },
    siteCoordinatorUserId: { type: ['number', 'null'] },
    recommendations: { type: ['string', 'null'] },
    dateCompleted: { type: ['string', 'null'] },
    role: { type: ['number', 'null'] },
    leadInspectorName: { type: ['string', 'null'] },
    clerkId: { type: ['number', 'null'] },
    clerkName: { type: ['string', 'null'] },
    proxyInspector: { type: ['string', 'null'] },
  },
};
